export default __webpack_public_path__ + "static/schoolyear-9d2941a3ceb2cb6c774a40590d615ce2.png";